import React__default from 'react';
import { CopyableText } from './CopyableText.mjs';
import { Instruction } from './Instruction.mjs';
import { SettingsListItem } from './SettingsListItem.mjs';

const IdpField = ({ title, value, isCopyable })=>/*#__PURE__*/ React__default.createElement(SettingsListItem, {
        title: title
    }, isCopyable ? /*#__PURE__*/ React__default.createElement(CopyableText, null, value) : /*#__PURE__*/ React__default.createElement(Instruction, null, value));

export { IdpField };
//# sourceMappingURL=IdpField.mjs.map
